import {ActionType, CleanResponse} from "../model";
import publicIp from "public-ip";
import {setAlert, setErrorAlert} from "./alert";


const paymentResponse = (response: { statusCode: number; message: any; body: any; }, dispatch: Function, message: string) => {
    if (response.statusCode === 400) {
        dispatch({
            type: ActionType.ALERT,
            payload: {
                message: response.message,
                statusCode: response.statusCode
            }
        });
        return false;
    } else {
        dispatch({
            type: ActionType.ALERT,
            payload: {
                message: message,
                statusCode: 200
            }
        });
        return response.body;
    }
}


export const updateStatusAdminActionItemStatus = (payload:any) => async (dispatch: Function, getState: Function, api: any) => {
    try {
        const response = await api.put('payment/updateStatusAdminActionItem',payload,{});
        dispatch({
            type: ActionType.ALERT,
            payload: {
                message: response.message,
                statusCode: 200
            }
        });
        return response.body;
    } catch (err) {
        dispatch({
            type: ActionType.ALERT,
            payload: {
                message: err.message ? err.message : err,
                statusCode: 400
            }
        });
        return {success : false, message : err.message ? err.message : err};
    }
}

export const policyDetails = (payload: any) => async (dispatch: Function, getState: Function, api: any)  => {
    try {
        const response = await api.post('payment/policy', payload, {});
        return response.body;
    } catch(err) {
        dispatch({
            type: ActionType.ALERT,
            payload: {
                message: err.message ? err.message : err,
                statusCode: 400
            }
        });
        return {success : false, message : err.message ? err.message : err};
    }
};

export const getPolicyDetails = (clientId:number) => async (dispatch: Function, getState: Function, api: { get: Function })  => {
    try {
        return await api.get('payment', {}, {clientId});
    } catch(err) {
        return dispatch({
            type: ActionType.ALERT,
            payload: err
        });
    }
};

export const createPayment = (payload: any) => async (dispatch: Function, getState: Function, api: any)  => {
    try {
        const ipAddress: string = await publicIp.v4();
        const resp = await api.post('payment', {ipAddress, ...payload}, {});
        dispatch({
            type: ActionType.ALERT,
            payload: {
                message: "Payment created successfully.",
                statusCode: 200
            }
        });
        return resp.body;
    } catch(err) {
        dispatch({
            type: ActionType.ALERT,
            payload: {
                message: err.message ? err.message : err,
                statusCode: 400
            }
        });
        return {statusCode: 400, success : false, message : err.message ? err.message : err};
    }
};

export const createPaymentSchedule = (payload: any, showError:boolean = true ) => async (dispatch: Function, getState: Function, api: any)  => {
    try {
        const ipAddress: string = await publicIp.v4();
        const resp = await api.post('payment/scheduled', {ipAddress, ...payload}, {});
        dispatch({
            type: ActionType.ALERT,
            payload: {
                message: "Payment done successfully.",
                statusCode: 200
            }
        });
        return resp.body;
    } catch(err) {
        if(showError){
            dispatch({
                type: ActionType.ALERT,
                payload: {
                    message: err.message ? err.message : err,
                    statusCode: 400
                }
            });
        }else{
            dispatch({
                type: ActionType.ALERT,
                payload: {
                    message: "Payment done successfully.",
                    statusCode: 200
                }
            });
        }
        return {statusCode: 400, success : false, message : err.message ? err.message : err};
    }
};

export const createManualPayment = (payload: any) => async (dispatch: Function, getState: Function, api: any)  => {
    try {
        const resp = await api.post('payment/mannual', payload, {});
        dispatch({
            type: ActionType.ALERT,
            payload: {
                message: "Payment created successfully.",
                statusCode: 200
            }
        });
        return resp.body;
    } catch(err) {
        dispatch({
            type: ActionType.ALERT,
            payload: {
                message: err.message ? err.message : err,
                statusCode: 400
            }
        });
        return {success : false, message : err.message ? err.message : err};
    }
};

export const processPayment = (payload: any) => async (dispatch: Function, getState: Function, api: any)  => {
    try {
        const resp = await api.post('payment/process', payload, {});
        // dispatch({
        //     type: ActionType.ALERT,
        //     payload: {
        //         message: "Payment Rejected successfully.",
        //         statusCode: 200
        //     }
        // });
        return resp.body;
    } catch(err) {
        dispatch({
            type: ActionType.ALERT,
            payload: {
                message: err.message ? err.message : err,
                statusCode: 400
            }
        });
        return {success : false, message : err.message ? err.message : err};
    }
};

export const deleteManualPayment = (payload: any) => async (dispatch: Function, getState: Function, api: any)  => {
    try {
        const resp = await api.delete('payment', payload, {});
        dispatch({
            type: ActionType.ALERT,
            payload: {
                message: "Payment deleted successfully.",
                statusCode: 200
            }
        });
        return resp.body;
    } catch(err) {
        dispatch({
            type: ActionType.ALERT,
            payload: {
                message: err.message ? err.message : err,
                statusCode: 400
            }
        });
        return {success : false, message : err.message ? err.message : err};
    }
};

export const addPaymentMethod = (payload: any) => async (dispatch: Function, getState: Function, api: any)  => {
    const message: string = "Payment method added successfully.";
    try {
        const response = await api.post('payment/method', payload, {});
        return paymentResponse(response, dispatch, message);
    } catch(err) {
        dispatch({
            type: ActionType.ALERT,
            payload: {
                message: err.message ? err.message : err,
                statusCode: 400
            }
        });
        return {success : false, message : err.message ? err.message : err};
    }
};

export const removePaymentMethod = (payload: any) => async (dispatch: Function, getState: Function, api: any)  => {
    const successMessage: string = "Payment method removed successfully.";
    try {
        await api.delete('payment/method', payload, {});
        dispatch({
            type: ActionType.ALERT,
            payload: {
                message: successMessage,
                statusCode: 200
            }
        });
        return {success : true, message : successMessage};
    } catch(err) {
        dispatch({
            type: ActionType.ALERT,
            payload: {
                message: err.message ? err.message : err,
                statusCode: 400
            }
        });
        return {success : false, message : err.message ? err.message : err};
    }
};
export const createActionItem = (payload: any) => async (dispatch: Function, getState: Function, api: any)  => {
    try {
        const response = await api.post('admin-actions/qc-action-item', payload, {});
        console.log("action item response: ", response);
        return response && response.body || {};
    } catch(err) {
        return dispatch({
            type: ActionType.ALERT,
            payload: err
        });
    }
};


export const createCheckWireActionItem = (payload: any) => async (dispatch: Function, getState: Function, api: any)  => {
    try {
        const response = await api.post('admin-actions/check-wire', payload, {});
        console.log("action item response: ", response);
        return response && response.body || {};
    } catch(err) {
        return dispatch({
            type: ActionType.ALERT,
            payload: err
        });
    }
};

export const updateQCActionItem = (payload: {status:string, userId:string, message:string, reason:string, type:string, actionType?: string}) => async (dispatch: Function, getState: Function, api: any)  => {
    try {
        const response = await api.put('admin-actions/qc-action-item', payload, {});
        console.log("action item response: ", response);
        return response && response.body || {};
    } catch(err) {
         dispatch({
            type: ActionType.ALERT,
            payload: err
        });
        return {success : false, message : err.message ? err.message : err};
    }
};

export const updateCheckWireActionItem = (payload: {status:string, userId:string, message:string, reason:string, type:string}) => async (dispatch: Function, getState: Function, api: any)  => {
    try {
        const response = await api.put('admin-actions/check-wire', payload, {});
        console.log("action item response: ", response);
        return response && response.body || {};
    } catch(err) {
        return dispatch({
            type: ActionType.ALERT,
            payload: err
        });
    }
};

export const getSaveSignedUrl = (payload: any) => async (dispatch: Function, getState: Function, api: { post: Function })  => {
    try {
        const response = await api.post('payment/document/save', payload, {});
        console.log("File Save: ", response);
        return response && response.body || {};
    } catch(err) {
        return dispatch({
            type: ActionType.ALERT,
            payload: err
        });
    }
};

export const getViewSignedUrl = (payload: any) => async (dispatch: Function, getState: Function, api: { post: Function })  => {
    try {
        const response = await api.post('payment/document/view', payload, {});
        console.log("File Get: ", response);
        return response && response.body || {};
    } catch(err) {
        return dispatch({
            type: ActionType.ALERT,
            payload: err
        });
    }
};

type CCWG1 = (payload: any) => (dispatch: Function, getState: Function, api: { post: Function }) => Promise<any>;
/**
 * Confirm Check Wire ePay Payment For Gen1
 * @param payload consisting of {gen1ClientPolicyId, gen2ClientPolicyId, paymentMethod} enum ClientPolicyPaymentMethod

 */
export const confirmPaymentForGen1: CCWG1 = (payload) => async (dispatch, _store, api) => {
    try {
        const response = await api.post('payment/gen1/confirm-payment-method', payload);
        return response.data;
    } catch (error) {
        return dispatch({
                type: ActionType.ALERT,
                payload: error
            }
        )
    }
}

export const rejectPayment = (payload: any) => async (dispatch: Function, getState: Function, api: { post: Function })  => {
    try {
        const response = await api.post('payment/reject', payload, {});
        dispatch({
            type: ActionType.ALERT,
            payload: {
                message: "Payment Rejected Successfully",
                statusCode: 200
            }
        });
        return { success: true, data: response.data }
    } catch(err) {
        dispatch({
            type: ActionType.ALERT,
            payload: err
        });
        return { success: false, data: {} }
    }
};

/**
 * Update Flexi payments (admin case details)
 * @param payload
 * @param params {policyID:string}
 */
 export const updateFlexiPayment = (payload: any, params: any) => async (dispatch: Function, _store: Function, api: any)  => {
 try {
        const resp = await api.post('payment/update/flexiPayment', payload, params);
        dispatch(setAlert(resp.message, 'success'));
        return;
    } catch(err) {
        return dispatch(setErrorAlert);
    }
};

/**
 * Fetch Upcoming Payments
 * @param payload
 */
export const setApprovePayments = (payload: any) => async (dispatch: Function, _state: Function, api: {
    put: Function
}) => {
    try {
        console.info(payload)
        const response: CleanResponse = await api.put('payment/approved', payload);
        dispatch({type: ActionType.APPROVE_PAYMENTS, payload: response.data});
        dispatch(setAlert(response.message, 'success'));
        return;
    } catch (err) {
        return dispatch(setErrorAlert);
    }
};

/**
 * Single payment (via servicing)
 * @param payload
 */
export const createSinglePayment = (payload: any) => async (dispatch: Function, _st: Function, api: { post: Function }) => {
    try {
        const ipAddress: string = await publicIp.v4();
        const resp = await api.post('payment/single', {ipAddress, ...payload}, {});
        if (resp.message) {
            dispatch(setAlert(resp.message, 'success'));
        }
        return resp.body;
    } catch (err) {
        return dispatch(setErrorAlert);
    }
};

/**
 * Client first payment
 * @param payload
 */
export const createFirstPayment = (payload: any) => async (dispatch: Function, _st: Function, api: {
    post: Function
}) => {
    try {
        const ipAddress: string = await publicIp.v4();
        const resp = await api.post('payment/first', {ipAddress, ...payload}, {});
        if (resp.message) {
            dispatch(setAlert(resp.message, 'success'));
        }
        return resp.body;
    } catch (err) {
        return dispatch(setErrorAlert);
    }
};

/**
 * Fetch Upcoming Payments
 * @param query
 */
export const fetchUpcomingPayments = (query: any) => async (dispatch: Function, _state: Function, api: {
    get: Function
}) => {
    try {
        const response: CleanResponse = await api.get('payment/upcoming', {}, query);
        dispatch({type: ActionType.FETCH_UPCOMING_PAYMENTS, payload: response.data});
        return;
    } catch (err) {
        return dispatch(setErrorAlert);
    }
};

/**
 * Fetch Payments Logs
 */
export const flushPaymentLogs = () => async (dispatch: Function, _state: Function, _api: Function) => {
    try {
        dispatch({type: ActionType.FLUSH_PAYMENT_LOGS, payload: []});
        return;
    } catch (err) {
        return dispatch(setErrorAlert);
    }
};

/**
 * Fetch Payments Logs
 * @param query
 * @param onlyErrors
 * @param isDebug
 */
export const fetchPaymentLogs = (query: any, onlyErrors: boolean, isDebug: boolean) => async (dispatch: Function, _state: Function, api: {
    post: Function
}) => {
    try {
        const response: CleanResponse = await api.post('payment/history', {isDebug, onlyErrors, ...query});
        dispatch({type: ActionType.FETCH_PAYMENT_LOGS, payload: response.data.body});
        return response.data.body;
    } catch (err) {
        return dispatch(setErrorAlert);
    }
};